module.exports = __webpack_public_path__ + "img/Болезни позвоночника.2eac9ded.jpg";